export default function formatNumber(number) {
  let numStr
  if (Number.isInteger(number)) {
    numStr = number.toString();
  } else {
    numStr = number.toFixed(2).toString();
  }

  return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}